import { z } from 'zod';

import { BasePType } from './base';
import { PTypes } from './index';

const baseLayoutSection = BasePType.extend({
  type: z.enum(['layoutSection']),
});

export type LayoutSection = z.infer<typeof baseLayoutSection> & {
  children?: PTypes[];
};

export const LayoutSection: z.ZodType<LayoutSection> = baseLayoutSection.extend(
  {
    children: z.lazy(() => z.array(PTypes)).optional(),
  }
);
